import path from 'path';

const EXCLUDE = [
  './index.js',
  './where.js',
];

const models = {};

(r => r.keys().filter(r => !EXCLUDE.includes(r)).forEach(key => {
  models[path.basename(key, '.js').toLowerCase()] = r(key);
}))(require.context('./', true, /\.js$/));

export default models;



// WEBPACK FOOTER //
// ./src/models/index.js